import { EMAIL_FIELD } from '@alfa-bank/site-envconfig';

const method = 'post';
const timeout = 1000;
const url = EMAIL_FIELD();
const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
};
const ref = 'email_complite';

export { method, timeout, url, headers, ref };
